import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { offlineRequest } from './offline.api';

function OfflineReminderItems({appId, entries, onRead}) {
  return entries.map(({ _id: entryId, ...entry })=><li key={entryId}><Link to={`/admin/crm/offline/${entry.customerId}?appId=${encodeURIComponent(appId)}`} onClick={()=>{
    offlineRequest(appId,`/entries/${entryId}/reminder/read`,{method:'patch'}).then(()=>onRead(entryId)).catch(()=>{});
  }}><div className="atbd-top-dropdwon__content notifications"><div className="notification-icon bg-secondary" style={{ borderRadius: 6 }}><FeatherIcon icon="calendar" /></div><div className="notification-text"><strong>Follow-up: {entry.customer_info.full_name}</strong><p>{entry.action_plan.next_action || 'Customer follow-up'} · {new Date(entry.action_plan.follow_up_date).toLocaleString()}</p></div></div></Link></li>);
}
OfflineReminderItems.propTypes={appId:PropTypes.string,entries:PropTypes.array.isRequired,onRead:PropTypes.func.isRequired};
export default OfflineReminderItems;
